module.exports = __webpack_public_path__ + "assets/img/0af6-au.svg";